export default "/images/vendor/flag-icons/flags/1x1/hu.svg?cb329e885950a7c054075d78aa6f1364";